/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.every.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CartPrdItem from './components/CartPrdItem';
import CartFiltrate from './components/CartFiltrate';
import AddressDesc from './components/AddressDesc';
import FixBottomBtn from './components/FixBottomBtn';
import FlexCell from '@/components/FlexCell';
import NoData from '@/components/NoData';
import NoDataImg from '@/resources/images/mall/noOrder.png';
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import Swipeout from "vux/src/components/swipeout/swipeout.vue";
import SwipeoutItem from "vux/src/components/swipeout/swipeout-item.vue";
import SwipeoutButton from "vux/src/components/swipeout/swipeout-button.vue";
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { GETTER_CLINICOBJ, MUTATION_MALL_ORDERINFOSURE } from '@/store/mutation_types';
import { CartSelect, CartEdit, CartDelete } from '@/api/mall';
export default {
  data: function data() {
    return {
      NoDataImg: NoDataImg,
      addressList: [],
      prdList: [],
      prdLoseList: [],
      isShop: true,
      invalid: true,
      showF: false,
      all: false,
      nowFilterList: [],
      isEdit: false,
      nowPrdItem: {},
      checkedNum: 0,
      orderList: [],
      nowCartId: '',
      //当前修改的购物记录id
      nowGoodsDetailId: '',
      //当前点击修改的购物记录下的商品具体规格id
      nowOrderObj: {},
      showFlag: -1
    };
  },
  created: function created() {
    this.cartInit();
  },
  watch: {},
  components: {
    CartPrdItem: CartPrdItem,
    FlexCell: FlexCell,
    AddressDesc: AddressDesc,
    FixBottomBtn: FixBottomBtn,
    Swipeout: Swipeout,
    SwipeoutItem: SwipeoutItem,
    SwipeoutButton: SwipeoutButton,
    NoData: NoData,
    CartFiltrate: CartFiltrate
  },
  directives: {
    TransferDom: TransferDom
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState({})), mapGetters({
    clinicObj: GETTER_CLINICOBJ
  })), {}, {
    // orderList(){
    //   return this.prdList.filter(x=>x.checked);
    // },
    priceNow: function priceNow() {
      var orderList = this.orderList,
          price = 0;

      if (orderList && orderList.length > 0) {
        var _iterator = _createForOfIteratorHelper(orderList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            price += parseFloat(item.price).toFixed(2) * parseInt(item.goodsQty);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      price = price.toFixed(2);
      return price;
    },
    clinicId: function clinicId() {
      return this.clinicObj && this.clinicObj.scrmClinic ? this.clinicObj.scrmClinic.clinicId : '';
    },
    appId: function appId() {
      return this.clinicObj && this.clinicObj.scrmClinic ? this.clinicObj.scrmClinic.appId : '';
    },
    isSubmit: function isSubmit() {
      var checkedNum = 0;
      var orderList = this.orderList;
      console.log('orderList:  ');
      console.log(orderList);
      checkedNum = orderList.length;

      if (checkedNum <= 0) {
        return false;
      } else {
        return true;
      }
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions([])), mapMutations({
    MUTATION_MALL_ORDERINFOSURE: MUTATION_MALL_ORDERINFOSURE
  })), {}, {
    //提交订单
    orderHandle: function orderHandle() {
      var prdList = this.prdList;
      var orderList = prdList.filter(function (x) {
        return x.checked;
      });

      if (!this.isSubmit) {
        return;
      } else {
        var _iterator2 = _createForOfIteratorHelper(orderList),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            item.isReal = 1;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        var orderInfo = {};
        orderInfo.orderList = orderList;
        orderInfo.isSubmit = true;
        this.MUTATION_MALL_ORDERINFOSURE(orderInfo);
        this.$router.push({
          name: 'MallOrderSure'
        });
      }
    },
    // 购物车列表
    cartInit: function cartInit() {
      var _this = this;

      CartSelect().then(function (data) {
        if (data.length > 0) {
          _this.showFlag = 1;
        } else {
          _this.showFlag = 0;
        }

        var _iterator3 = _createForOfIteratorHelper(data),
            _step3;

        try {
          var _loop = function _loop() {
            var item = _step3.value;
            var detailItem = item.goodsSpecifitionList.find(function (x) {
              return x.goodsDetailId == item.goodsSpecifitionId;
            });

            if (detailItem) {
              item.inventory = detailItem.inventory;
            }
          };

          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        _this.prdList = data.filter(function (x) {
          return x.goodsStatus == 0 && x.inventory > 0;
        });
        _this.prdLoseList = data.filter(function (x) {
          return x.goodsStatus != 0 || x.inventory <= 0;
        });
        _this.orderList = _this.prdList.filter(function (x) {
          return x.checked;
        });
      });
    },
    // 进入微商场
    goMall: function goMall() {
      this.$router.push({
        name: 'MallIndex'
      });
    },
    // 规格+数量修改
    cartSpec: function cartSpec(list, flag) {
      var item = list[0],
          type = list[1];
      var nowOrderObj = {};
      nowOrderObj = item;
      this.nowFilterList = item.goodsSpecifitionList;
      this.nowCartId = item.cartId;
      this.nowGoodsDetailId = item.goodsSpecifitionId;

      if (type == 'spec') {
        this.showF = true;
      } else {
        this.editCart(nowOrderObj);
      }
    },
    //规格选完确定
    filterConfirm: function filterConfirm(result) {
      var _this2 = this;

      console.log('result');
      var prdList = JSON.parse(JSON.stringify(this.prdList));
      var item = prdList.find(function (x) {
        return x.cartId == _this2.nowCartId;
      });
      var itemObj = {};
      itemObj.goodsId = item.goodsId;
      itemObj.goodsQty = item.goodsQty;
      itemObj.goodsSpecifitionId = result.goodsDetailId;
      itemObj.goodsDetailIdBefore = result.goodsDetailIdBefore;
      itemObj.cartId = item.cartId;
      var goodsItem = item.goodsSpecifitionList.find(function (x) {
        return x.goodsDetailId == result.goodsDetailId;
      });
      item.goodsSpecifition = goodsItem.specification;
      itemObj.goodsSpecifition = item.goodsSpecifition;
      this.editCart(itemObj, 'spec');
      console.log(result);
    },
    //修改购物车--调用接口
    editCart: function editCart(obj, type) {
      var _this3 = this;

      var itemObj = JSON.parse(JSON.stringify(obj));
      itemObj.clinicId = this.clinicId;
      itemObj.appId = this.appId;

      if (itemObj.goodsSpecifitionList) {
        delete itemObj.goodsSpecifitionList;
      }

      var cartList = [itemObj];
      cartList = JSON.stringify(cartList);
      console.log("cartList:    ");
      console.log(cartList);
      var prdList, prdItem;
      CartEdit(cartList).then(function (data) {
        prdList = _this3.prdList;
        prdItem = prdList.find(function (x) {
          return x.cartId == itemObj.cartId;
        });

        if (type && type == 'spec') {
          _this3.cartInit();
        } else {
          _this3.prdList = prdList;
          _this3.orderList = _this3.prdList.filter(function (x) {
            return x.checked;
          });
        }
      })["catch"](function (error) {
        prdList = _this3.prdList;
        prdItem = prdList.find(function (x) {
          return x.cartId == itemObj.cartId;
        });
        prdItem.goodsQty = itemObj.goodsQtyBefore || prdItem.goodsQty;
        prdItem.goodsDetailId = itemObj.goodsDetailIdBefore;
        _this3.nowGoodsDetailId = itemObj.goodsDetailIdBefore;
        console.log('error');
      });
    },
    // 设置规格弹窗显示
    setShow: function setShow(val) {
      this.showF = val;
    },
    // 全选
    radioAll: function radioAll(val) {
      this.all = val;
      var prdList = this.prdList;

      for (var i in prdList) {
        prdList[i].checked = this.all;
      }

      this.prdList = prdList;

      if (val) {
        this.checkedNum = this.prdList.length;
      }

      this.orderList = this.prdList.filter(function (x) {
        return x.checked;
      });
    },
    // 点击选择icon
    radioChecked: function radioChecked(item) {
      var prdList = this.prdList;
      var prdItem = prdList.find(function (x) {
        return x.cartId == item.cartId;
      });
      var all = prdList.every(function (x) {
        return x.checked;
      });
      this.all = all;
      this.prdList = prdList;
      this.orderList = this.prdList.filter(function (x) {
        return x.checked;
      });
    },
    //delCart--删除购物车
    delCart: function delCart(cartId) {
      var _this4 = this;

      var cartIds = [];
      cartIds = [cartId];
      cartIds = JSON.stringify(cartIds);
      CartDelete(cartIds).then(function (data) {
        // Public.tips({text:'删除订单成功~'});
        _this4.prdList = _this4.prdList.filter(function (x) {
          return x.cartId != cartId;
        });

        if (_this4.prdList.length <= 0 && _this4.prdLoseList.length <= 0) {
          _this4.showFlag = 0;
        }

        _this4.orderList = _this4.prdList.filter(function (x) {
          return x.checked;
        });
      });
    },
    //清空失效宝贝
    clearLosePrd: function clearLosePrd() {
      var _this5 = this;

      var cartIds = [];

      var _iterator4 = _createForOfIteratorHelper(this.prdLoseList),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var item = _step4.value;
          cartIds.push(item.cartId);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      cartIds = JSON.stringify(cartIds);
      CartDelete(cartIds).then(function (data) {
        // Public.tips({text:'删除订单成功~'});
        _this5.prdLoseList = [];

        if (_this5.prdList.length <= 0 && _this5.prdLoseList.length <= 0) {
          _this5.showFlag = 0;
        }
      });
    }
  })
};